import { CATALOG } from "./catalog.generated";
import { OVERRIDES } from "./langs";
import { LanguageRegistry } from "./registry";

export { COMMENTS, defaultConfig } from "./config";
export { basename, defineLanguage, LanguageRegistry, PLAINTEXT_ID } from "./registry";
export type {
  CatalogEntry,
  GrammarLoader,
  GrammarModule,
  LanguageConfig,
  LanguageDescriptor,
  LanguageOverride,
} from "./types";

/** The app-wide registry: every Shiki grammar plus local overrides. */
export const languages = new LanguageRegistry(CATALOG, OVERRIDES);
export {
  type ContentClassifier,
  type ContentDetectionOptions,
  ContentDetector,
  createWorkerClassifier,
  type ModelResult,
  pickLanguage,
  resolveModelLabel,
} from "./detect/content";
export { detectLanguage } from "./detect/detect";
export {
  DEFAULT_STAGES,
  extensionStage,
  filenameStage,
  modelineLanguage,
  modelineStage,
  plaintextStage,
  shebangInterpreter,
  shebangStage,
} from "./detect/stages";
export type { Detection, DetectionInput, DetectionSource, DetectionStage } from "./detect/types";
